import styled, { keyframes } from 'styled-components';

export const Panel = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #E0E4EA;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

export const Section = styled.div`
  &:not(:last-child) {
    border-bottom: 1px solid #F2F2F2;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 20px 10px;
`;


export const SectionLabel = styled.span`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.Primary};
`;

export const ResultRow = styled.a`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 20px;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.1s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.Primary}0D;
  }

  &:last-child {
    padding-bottom: 14px;
  }
`;


export const ResultText = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ResultTitle = styled.p`
  margin: 0;
  font-size: 15px;
  font-weight: 400;
  color: #2D3436;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;

  strong {
    font-weight: 700;
    color: #2D3436;
  }
`;

export const ResultSubtitle = styled.p`
  margin: 2px 0 0;
  font-size: 12px;
  color: #B2BEC3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ResultBadge = styled.span`
  flex-shrink: 1;
  min-width: 0;
  max-width: 40%;
  font-size: 12px;
  font-weight: 500;
  color: #2D3436;
  background: ${({ theme }) => theme.colors.Primary}15;
  border-radius: 6px;
  padding: 3px 9px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ShowMoreBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 10px 20px 14px;
  border: none;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  color: #3b82f6;
  cursor: pointer;
  text-align: left;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.75;
  }
`;

export const EmptyState = styled.div`
  padding: 32px 20px;
  text-align: center;
  font-size: 15px;
  color: #636E72;
`;

export const ErrorState = styled.div`
  padding: 32px 20px;
  text-align: center;
  font-size: 15px;
  color: #636E72;
`;

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

export const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 20px;
`;

export const SkeletonIcon = styled.div`
  width: 24px;
  height: 20px;
  border-radius: 4px;
  background: linear-gradient(90deg, #F2F2F2 25%, #E8E8E8 50%, #F2F2F2 75%);
  background-size: 400px 100%;
  animation: ${shimmer} 1.2s infinite linear;
  flex-shrink: 0;
`;

export const SkeletonLine = styled.div<{ width?: string }>`
  height: 14px;
  border-radius: 4px;
  width: ${({ width }) => width || '60%'};
  background: linear-gradient(90deg, #F2F2F2 25%, #E8E8E8 50%, #F2F2F2 75%);
  background-size: 400px 100%;
  animation: ${shimmer} 1.2s infinite linear;
`;

export const SkeletonBadge = styled.div`
  width: 56px;
  height: 20px;
  border-radius: 6px;
  background: linear-gradient(90deg, #F2F2F2 25%, #E8E8E8 50%, #F2F2F2 75%);
  background-size: 400px 100%;
  animation: ${shimmer} 1.2s infinite linear;
  flex-shrink: 0;
`;
